import React from 'react'
import { SvgIcon } from '@mui/material'

import CheckCircleIcon from '@hapana/shared/web/styles/assets/svgs/check-circle-small.svg'

/** @type {MuiComponents['MuiDialog']} */

const overwrite = {
  defaultProps: {
    iconMapping: {
      info: false,
      success: <SvgIcon sx={{ color: 'gray.0' }} component={CheckCircleIcon} />,
    },
    variant: 'filled',
  },
}

export const MuiAlert = overwrite
